import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { initFCM } from './firebase';
import reportWebVitals from './reportWebVitals';
import './translations/i18n';
import { initServiceWorkers } from './workers';

// service worker must be initialized before the app
initServiceWorkers();
// fcm must be initialized before subscribing to notifications
initFCM();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
